import styled from 'styled-components';

export const Padded = styled.div<{ size?: 'sm' | 'md' | 'lg' | string }>`
  ${({ size }) => {
    switch (size) {
      case 'sm':
        return 'padding: 0.5em;';
      case 'md':
        return 'padding: 1em;';
      case 'lg':
        return 'padding: 2em;';
      default:
        if (size) {
          return `padding: ${size};`;
        }
        return 'padding: 2em;';
    }
  }}
`;
